import { useRef } from 'react';
import PropTypes from 'prop-types';

import TextViewMore from '@components/ViewMore/TextViewMore/TextViewMore';
import Image from 'next/image';
// import { request } from '@apis/utils';
// import PortfolioViewer from '@hiredigital/ui/PortfolioViewer/PortfolioViewer';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';
// import { getUserPortfolioItemByUuid } from '@apis/portfolioItems';

import PortfolioRow from './PortfolioRow';

import Styles from './TalentCard.module.scss';

const TalentCard = ({ user, showPortfolio, analyticsData, isPrivate, author }) => {
  const itemRef = useRef();
  const updatedKey = user.accessKey || user.username;
  const url = isPrivate ? `/talent/resumes/${updatedKey}` : `/resumes/${updatedKey}`;
  if (showPortfolio && !user.portfolioItems) {
    console.info(`Portfolio Items missing for ${user.username}`);
  }

  const openViewer = (item) => {
    console.log('disabled');
    // itemRef.current.open(item);
  };
  return (
    <div className={Styles.cardContainer}>
      <div className={Styles.cardInnerContainer}>
        <div className={Styles.left}>
          <a href={url} target='_blank' title={user.name}>
            <div className={Styles.avatarContainer}>
              <Image
                className={Styles.avatar}
                height={200}
                width={200}
                src={user.picture}
                alt={user.name}
              />
            </div>
          </a>
          <div className={Styles.onlyDesktop}>
            <InteractiveButton
              type={InteractiveButton.Type.DARKBLUE}
              className={Styles.button}
              href={{
                pathname: '/get-started',
                query: { talentName: updatedKey, ...analyticsData },
              }}
              target='_blank'>
              <span className={Styles.innerButton}>{`Work with ${user.firstName}`}</span>
            </InteractiveButton>
          </div>
        </div>
        <div className={Styles.right}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <div className={Styles.titleAndPosition}>
                <div className={Styles.positionTitle}>
                  {author ? `About the Author` : user.primarySkillTitle}
                </div>
              </div>
              <div className={Styles.name}>
                <a href={url} target='_blank' title={user.name}>
                  {user.name}
                </a>
              </div>
            </div>
          </div>
          <div className={Styles.headline}>{user.headline}</div>
          <div className={Styles.longDescription} data-nosnippet>
            <TextViewMore lines={4} text={user.description} />
          </div>
          {showPortfolio && user.portfolioItems && (
            <div className={Styles.portfolio}>
              {' '}
              <PortfolioRow portfolios={user.portfolioItems} openViewer={openViewer} />
            </div>
          )}
          <div className={Styles.onlyPhone}>
            <InteractiveButton
              type={InteractiveButton.Type.DARKBLUE}
              className={Styles.button}
              href={{
                pathname: '/get-started',
                query: { talentName: updatedKey, ...analyticsData },
              }}
              target='_blank'>
              <span className={Styles.innerButton}>{`Work with ${user.firstName}`}</span>
            </InteractiveButton>
          </div>
        </div>
      </div>
      {/* <PortfolioViewer
        request={request}
        items={user.portfolioItems}
        ref={itemRef}
        getItem={getUserPortfolioItemByUuid}
      />*/}
    </div>
  );
};

TalentCard.propTypes = {
  showPortfolio: PropTypes.bool,
  user: PropTypes.shape({
    uuid: PropTypes.string,
    username: PropTypes.string,
    firstName: PropTypes.string,
    name: PropTypes.string,
    headline: PropTypes.string,
    description: PropTypes.string,
    picture: PropTypes.string,
    primarySkillTitle: PropTypes.string,
    skills: PropTypes.array,
    portfolioItems: PropTypes.array,
  }),
};

export default TalentCard;
